import { namespacer } from 'helpers'

const namespace = namespacer('INSTITUTION_PROFILE')
export const INSTITUTION_BILLING_ADDRESS_SUCCESS = namespace('INSTITUTION_BILLING_ADDRESS_SUCCESS')
